const stateObj = {
  rwOptions: null,
};

const mutations = {
  setOptions(state, rwOptions) {
    // eslint-disable-next-line no-param-reassign
    state.rwOptions = rwOptions;
  },
};

const actions = {
  // eslint-disable-next-line require-await
  async loadOptions(context) {
    context.commit('setOptions', window.rwOptions);
  },
};

const getters = {
  rwOptions: (state) => state.rwOptions,
  isUnderMaintenance: (state) => (state.rwOptions === null ? null : state.rwOptions.IS_UNDER_MAINTENANCE),
  maintenanceMsg: (state) => (state.rwOptions === null ? null : state.rwOptions.MAINTENANCE_MSG),
};

export default {
  namespaced: true,
  state: stateObj,
  mutations,
  actions,
  getters,
};
